module.exports = __webpack_public_path__ + "img/massagebprof2.dd5f4ac8.jpg";